import React from 'react'
import { Row, Col, Collapse,  } from 'antd';
import { translate } from 'react-i18next';

const { Panel } = Collapse;

function callback(key) {
    console.log(key);
}

const SupportFaqsTab = ({ t }) => {
    return (
        <Row justify="center">
            <Col xl={10} lg={10} md={20} sm={20} xs={20}>
                <div className="header-card-faq">
                    <div className="header-card-font-faq">{t("faq_form.getting_started")}</div>
                </div>
                
                <Collapse
                    className="collapse-faqs-tab"
                    defaultActiveKey={['4']}
                    onChange={callback}
                    accordion
                    
                >
                    <Panel header={t("faq_form.getting_started_quest_1")} key="1">
                        {t("faq_form.getting_started_answer_1")}
                    </Panel>
                    <Panel header={t("faq_form.getting_started_quest_2")} key="2">
                        {t("faq_form.getting_started_answer_2")}
                    </Panel>
                    <Panel header={t("faq_form.getting_started_quest_3")} key="3">
                        {t("faq_form.getting_started_answer_3")} <a href="https://vroom.truevirtualworld.com/portal">https://vroom.truevirtualworld.com/portal</a> {t("faq_form.getting_started_answer_3_1")}
                    </Panel>
                    
                </Collapse>
                <div className="header-card-faq">
                    <div className="header-card-font-faq">{t("faq_form_2.join")}</div>
                </div>
                <Collapse
                    className="collapse-faqs-tab"
                   // defaultActiveKey={['4']}
                    onChange={callback}
                    accordion
                    
                >
                    <Panel header={t("faq_form_2.join_quest_1")} key="1">
                        {t("faq_form_2.join_answer_1")} <a href="https://vroom.truevirtualworld.com/portal">https://vroom.truevirtualworld.com/portal</a> {t("faq_form_2.join_answer_1_1")}
                    </Panel>
                    <Panel header={t("faq_form_2.join_quest_2")} key="2">
                        {t("faq_form_2.join_answer_2")}
                    </Panel>
                    <Panel header={t("faq_form_2.join_quest_3")} key="3" >
                        {t("faq_form_2.join_answer_3")}
                    </Panel>
                    <Panel header={t("faq_form_2.join_quest_4")} key="4">
                        {t("faq_form_2.join_answer_4")}
                    </Panel>
                    <Panel header={t("faq_form_2.join_quest_5")} key="5">
                        {t("faq_form_2.join_answer_5")}
                    </Panel>
                    
                </Collapse>
                <div className="header-card-faq">
                    <div className="header-card-font-faq">{t("faq_form_3.scheduling")}</div>
                </div>
                <Collapse
                    className="collapse-faqs-tab"
                    defaultActiveKey={['4']}
                    onChange={callback}
                    accordion
                    
                >
                    <Panel header={t("faq_form_3.scheduling_quest_1")} key="1">
                        {t("faq_form_3.scheduling_answer_1")} <a href="https://vroom.truevirtualworld.com/portal">https://vroom.truevirtualworld.com/portal</a> {t("faq_form_3.scheduling_answer_1_1")}
                    </Panel>
                    <Panel header={t("faq_form_3.scheduling_quest_2")} key="2">
                        {t("faq_form_3.scheduling_answer_2")}
                    </Panel>
                   
                </Collapse>
                <div className="header-card-faq">
                    <div className="header-card-font-faq">{t("faq_form_4.vroom_account")}</div>
                </div>
                <Collapse
                    className="collapse-faqs-tab"
                    defaultActiveKey={['4']}
                    onChange={callback}
                    accordion
                    
                >
                    <Panel header={t("faq_form_4.vroom_account_quest_1")} key="1">
                        {t("faq_form_4.vroom_account_answer_1")} <a href="https://vroom.truevirtualworld.com/portal">https://vroom.truevirtualworld.com/portal</a> {t("faq_form_4.vroom_account_answer_1_1")}
                    </Panel>
                   
                </Collapse>
                <div className="header-card-faq">
                    <div className="header-card-font-faq">{t("faq_form_5.troubleshooting")}</div>
                </div>
                <Collapse
                    className="collapse-faqs-tab"
                    defaultActiveKey={['4']}
                    onChange={callback}
                    accordion
                    
                >
                    <Panel header={t("faq_form_5.troubleshooting_quest_1")} key="1">
                        {t("faq_form_5.troubleshooting_answer_1")} 
                    </Panel>
                   
                </Collapse>
            </Col>
        </Row>
    )
}

export default translate()(SupportFaqsTab)
